<template>
  <div class="production_wrap">
    <div class="production_img" :style="{ background: `url(${prodOne.image}) 0 0 no-repeat`, backgroundSize: '100%' }">
      <div class="img_tit">{{ prodOne.title }}</div>
      <div class="img_desc">{{ prodOne.subtitle }}</div>
      <router-link class="img_btn" to="/demo">立即体验</router-link>
    </div>
    <div class="production_title_wrap">
      <div class="production_inner">
        <div class="inner_left">
          <img src="../../assets/img/tupianright.png" alt="" />
        </div>
        <div class="inner_center">
          <div class="production_title">{{ prodTwo.title }}</div>
          <div class="production_desc">{{ prodTwo.subtitle }}</div>
        </div>
        <div class="inner_right">
          <img src="../../assets/img/tupianleft.png" alt="" />
        </div>
      </div>
    </div>
    <div class="production_box">
      <div class="production_item" v-for="item in prodTwoChildren">
        <div class="item_left">
          <img :src="item.image" alt="" />
        </div>
        <div class="item_right">
          <div class="right_tit">{{ item.title }}</div>
          <div class="right_desc">
            {{ item.subTitle }}
          </div>
        </div>
      </div>
    </div>
    <div class="production_title_wrap">
      <div class="production_inner">
        <div class="inner_left">
          <img src="../../assets/img/tupianright.png" alt="" />
        </div>
        <div class="inner_center" style="width:40%;">
          <div class="production_title">{{ prodThree1.title }}</div>
          <div class="production_desc">
            {{ prodThree1.subtitle }}
          </div>
        </div>
        <div class="inner_right">
          <img src="../../assets/img/tupianleft.png" alt="" />
        </div>
      </div>
    </div>
    <div style="height: 20px;"></div>
    <div class="production_core_scene"></div>
    <div class="production_card">
      <ProCard :procardList="procardList" :prodProp="prodThreeProp" />
    </div>
    <div style="height: 20px;"></div>
    <div class="production_card">
      <ProCard2 :procardList="procardList2" :prodProp="prodFourProp" />
    </div>
    <div class="production_title_wrap">
      <div class="production_inner">
        <div class="inner_left">
          <img src="../../assets/img/tupianright.png" alt="" />
        </div>
        <div class="inner_center" style="width: 40%;">
          <div class="production_title">{{ prodFive1.title }}</div>
        </div>
        <div class="inner_right">
          <img src="../../assets/img/tupianleft.png" alt="" />
        </div>
      </div>
    </div>
    <div class="advantage_out_wrap">
      <AdvantageCard :advantageList="prodFive2" />
    </div>
    <div class="production_title_wrap">
      <div class="production_inner">
        <div class="inner_left">
          <img src="../../assets/img/tupianright.png" alt="" />
        </div>
        <div class="inner_center" style="width: 60%">
          <div class="production_title">
            {{ prodSix1.title }}
          </div>
        </div>
        <div class="inner_right">
          <img src="../../assets/img/tupianleft.png" alt="" />
        </div>
      </div>
    </div>
    <imageScroll :showImages="prodSix2" />
    <div class="product_shows_wrap">
      <div class="production_title_wrap">
        <div class="production_inner">
          <div class="inner_left">
            <img src="../../assets/img/tupianright.png" alt="" />
          </div>
          <div class="inner_center">
            <div class="production_title">{{ prodServen1.title }}</div>
            <div class="production_desc">
              {{ prodServen1.subtitle }}
            </div>
          </div>
          <div class="inner_right">
            <img src="../../assets/img/tupianleft.png" alt="" />
          </div>
        </div>
      </div>
      <div class="with_center">
        <div class="bottom_img_wrap">
          <div class="bottom_img_item" v-for="(item, index) in prodServen2" :key="index">
            <h2 class="hidden-xs-only">{{ item.Title }}</h2>
            <div class="bottom_img">
              <img :src="item.Image" alt="" />
              <div class="img_desc">{{ item.SubTitle }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import ProCard from './ProCard.vue'
import ProCard2 from './ProCard2.vue'
import AdvantageCard from './AdvantageCard.vue'
import imageScroll from './imageScroll.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import { leftLikeDict } from '../../api/system'
import { findMainProp, findMainPropArr, transDictDataNotTypeMore, transDictDataNotTypeMore2, transDictDataNotTypeMoreSpec, transDictDataTotal } from '../../utils'
import Constant from '../../utils/Constant'
export default {
  data() {
    return {
      prodOne: {
      },
      prodTwo: {},
      prodThree1: {},
      prodThree2: [],
      prodTwoChildren: [],
      prodThreeProp: [],
      prodFour2: [],
      prodFive1: {},
      prodFive2: [],
      prodSix1: {},
      prodSix2: [],
      prodServen1: {},
      prodServen2: [],
      prodFiveProp: [],
      prodFourProp: [],
      procardList: [
      ],
      procardList2: [
      ],
    }
  },
  components: {
    ProCard,
    ProCard2,
    AdvantageCard,
    imageScroll,
    CallMe,
    MobileCallme,
  },
  methods: {
    async leftLikeDictFunc() {
      const res = await leftLikeDict(Constant.PROD_ONE1);
      if (res.data) {
        this.prodOne = findMainProp(res.data.data, Constant.PROD_ONE1)
      }
      const res2 = await leftLikeDict(Constant.PROD_ONE2);
      if (res2.data) {
        this.prodTwo = findMainProp(res2.data.data, Constant.PROD_ONE2)
        const transData = transDictDataNotTypeMore(res2.data.data.find(v => v.dictKey === 'prod_one2Title')?.children, 'prod_one2Content')
        this.prodTwoChildren = transData
      }
      const res3 = await leftLikeDict(Constant.PROD_ONE3);
      if (res3.data) {
        this.prodThree1 = findMainProp(res3.data.data, Constant.PROD_ONE3)
        this.prodThree2 = findMainPropArr(res3.data.data, Constant.PROD_ONE3)
        this.prodThree2.map(v => {
          this.procardList.push({ tit: v.type })
        })
        for (let i = 1; i <= this.prodThree2.length; i++) {
          this.prodThreeProp.push({
            image: this.prodThree2[i - 1].image,
            title: res3.data.data.find(v => v.dictKey === `prod_one3Type${i}`)?.children.find(v => v.dictKey === `prod_one3Content${i}Title`)?.dictValue,
            children: transDictDataNotTypeMore2(res3.data.data.find(v => v.dictKey === `prod_one3Type${i}`)?.children, `prod_one3Content${i}`)
          })
        }
      }
      const res4 = await leftLikeDict(Constant.PROD_ONE4);
      if (res4.data) {
        this.prodFour2 = findMainPropArr(res4.data.data, Constant.PROD_ONE4)
        this.prodFour2.map(v => {
          this.procardList2.push({ tit: v.type })
        })
        for (let i = 1; i <= this.prodFour2.length; i++) {
          this.prodFourProp.push({
            image: this.prodFour2[i - 1].image,
            title: res4.data.data.find(v => v.dictKey === `prod_one4Type${i}`)?.children.find(v => v.dictKey === `prod_one4Content${i}Title`)?.dictValue,
            children: transDictDataNotTypeMore2(res4.data.data.find(v => v.dictKey === `prod_one4Type${i}`)?.children, `prod_one4Content${i}`)
          })
        }
      }
      const res5 = await leftLikeDict(Constant.PROD_ONE5);
      if (res5.data) {
        this.prodFive1 = findMainProp(res5.data.data, Constant.PROD_ONE5)
        this.prodFive2 = transDictDataTotal(res5.data.data.find(v => v.dictKey === `prod_one5Title`)?.children, `prod_one5Content`)
      }
      const res6 = await leftLikeDict(Constant.PROD_ONE6);
      if (res6.data) {
        this.prodSix1 = findMainProp(res6.data.data, Constant.PROD_ONE6)
        this.prodSix2 = transDictDataTotal(res6.data.data.find(v => v.dictKey === `prod_one6Title`)?.children, `prod_one6Content`)
      }
      const res7 = await leftLikeDict(Constant.PROD_ONE7);
      if (res7.data) {
        this.prodServen1 = findMainProp(res7.data.data, Constant.PROD_ONE7)
        this.prodServen2 = transDictDataTotal(res7.data.data.find(v => v.dictKey === `prod_one7Title`)?.children, `prod_one7Content`)
        console.log('@', this.prodServen1, this.prodServen2);

      }
    }
  },
  mounted() {
    this.leftLikeDictFunc()
  }
}
</script>

<style lang="scss" scoped>
.production_wrap {
  width: 100%;

  .production_img {
    width: 100%;
    height: 600px;

    @media screen and (max-width: 768px) {
      height: 50vw;
    }

    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;

    .img_tit {
      font-size: 60px;
      font-weight: bold;

      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }
    }

    .img_desc {
      font-size: 32px;
      margin-top: 20px;

      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }

    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        color: #fff;
        background: orange;
      }

      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }

  .production_title_wrap {
    width: 100%;
    margin-top: 50px;

    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }

    .production_inner {
      display: flex;
      justify-content: center;

      .inner_left {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        @media screen and (max-width: 768px) {
          flex: 1;
        }

        img {
          width: 30%;
        }
      }

      .inner_center {
        width: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 50px;

        @media screen and (max-width: 768px) {
          flex: 2.2;
        }

        .production_title {
          font-size: 40px;
          font-weight: bold;

          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }
        }

        .production_desc {
          font-size: 16px;
          color: #787878;
          margin-top: 10px;

          @media screen and (max-width: 768px) {
            margin-top: 10px;
            font-size: 14px;
          }
        }
      }

      .inner_right {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        @media screen and (max-width: 768px) {
          flex: 1;
        }

        img {
          width: 30%;
        }
      }
    }
  }

  .production_box {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 50px;
    margin-bottom: 100px;

    @media screen and (max-width: 768px) {
      justify-content: space-around;
      flex-wrap: wrap;
    }

    .production_item {
      width: 30%;
      display: flex;
      margin-left: 80px;

      @media screen and (max-width: 768px) {
        width: 90%;
        margin-left: 0;
        margin-top: 20px;
      }

      .item_left {
        width: 50%;
        padding: 0 30px;

        img {
          width: 100%;
        }
      }

      .item_right {
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        @media screen and (max-width: 768px) {
          margin-left: 10px;
        }

        .right_tit {
          font-weight: bold;
          font-size: 26px;

          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }
        }

        .right_desc {
          color: #717171;
          font-size: 16px;

          @media screen and (max-width: 768px) {
            font-size: 0.8rem;
            line-height: 18px;
          }
        }
      }
    }
  }

  p {
    text-align: center;
    color: #3b3b3b;
    font-weight: bold;
    font-size: 20px;
    line-height: 100px;

    @media screen and (max-width: 768px) {
      font-size: 0.9rem;
      padding: 15px 0;
    }
  }

  .production_card {
    display: flex;
    justify-content: center;
  }

  .advantage_out_wrap {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .carousel_pro {
    width: 60%;
    margin: 60px auto;

    .carousel_pro_item {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .product_shows_wrap {
    width: 100%;
    background: url('../../assets/img/witness-bgc369221.png') 0 0 no-repeat;
    background-size: cover;
    padding: 10px 0 50px 0;
    margin-top: 100px;
    box-sizing: border-box;

    .with_center {
      display: flex;
      justify-content: center;

      .bottom_img_wrap {
        width: 80%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        @media screen and (max-width: 768px) {
          width: 100%;
        }

        .bottom_img_item {
          width: 30%;
          display: flex;
          flex-wrap: wrap;
          margin-top: 20px;
          margin: 20px;

          h2 {
            color: #3b3b3b;
          }

          @media screen and (max-width: 768px) {
            width: 45%;
          }

          .bottom_img {
            width: 100%;
            position: relative;

            img {
              width: 100%;
            }

            .img_desc {
              position: absolute;
              bottom: 20px;
              width: 100%;
              text-align: center;
              color: #fff;
              font-size: 18px;

              @media screen and (max-width: 768px) {
                font-weight: bold;
                bottom: 8px;
                font-size: 13px;
              }
            }
          }
        }
      }
    }
  }
}
</style>